export default __webpack_public_path__ + "static/media/icone-bing-ads.183f8dc8.svg";